var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hello"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "auto"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索车辆信息..."
    },
    on: {
      "on-change": _vm.searchVehicle
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchVehicle
    },
    slot: "append"
  })], 1), _c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadVehicle
    }
  }), _vm.user.superAdmin || _vm.arrayIntersection(['deliveryLeader'], _vm.user.simpleRole).length > 0 ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.EditVehicleDrawer.openDrawer();
      }
    }
  }, [_vm._v("新增车辆信息")]) : _vm._e()], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditVehicleDrawer', {
    ref: "EditVehicleDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }